import React from "react";
import cls from "./RealtimeDiff.module.css";

/**
 * @param {{ diff?: { changed?: boolean, vehiclesDelta?: number, countDelta?: number, personnelDelta?: number }, title?: string }} props
 */
export default function DiffBadge({ diff, title }) {
  if (!diff || !diff.changed) return null;
  const delta = diff.vehiclesDelta ?? diff.countDelta ?? 0;
  if (delta === 0) return null;
  const sign = delta > 0 ? "▲" : "▼";
  const clsName = delta > 0 ? cls.diffUp : cls.diffDown;
  const tip =
    title ??
    (diff.personnelDelta != null
      ? `인원 ${diff.personnelDelta >= 0 ? "+" : ""}${diff.personnelDelta}`
      : undefined);
  return (
    <span className={clsName} title={tip}>
      {sign}
      {Math.abs(delta)}
    </span>
  );
}
